import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useSettings from './useSettings';
import axios from '../utils/axios';
// config
import { allLangs, defaultLang } from '../config';
// utils
import { getCurrentLanguagePath } from '../utils/languageUtils';

// ----------------------------------------------------------------------

export default function useLocales() {
  const { i18n, t: translate } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { user, isAuthenticated } = useSelector((state) => state.auth);

  const { onChangeDirectionByLang } = useSettings();

  const currentLang = allLangs.find((_lang) => _lang.value === i18n.language) || defaultLang;

  const handleChangeLanguage = async (newlang) => {
    i18n.changeLanguage(newlang);
    onChangeDirectionByLang(newlang);
    localStorage.setItem('language', newlang);
    localStorage.setItem('preferredLanguage', newlang);

    // Save language preference to backend if user is authenticated
    if (isAuthenticated && user) {
      try {
        await axios.post('/api/v1/sporeuser/update_language_preference/', {
          language: newlang
        });
        // Language preference saved
      } catch (error) {
        // Don't block the language change if backend save fails
      }
    }

    // Navigate to same page in new language (no page reload)
    const newPath = getCurrentLanguagePath(location.pathname, newlang);
    navigate(newPath, { replace: true });
  };

  return {
    onChangeLang: handleChangeLanguage,
    translate: (text, options) => translate(text, options),
    currentLang,
    allLangs,
  };
}
